/*
 * Changes:
 * - Added 'use client' directive for Next.js 13+ compatibility
 * - File contains client-side features: React hooks and context provider
 */

'use client'

import {createContext, useContext} from 'react'

interface UploadContext {
  uploadUrl: string
  accessToken: string
}

const UploadContext = createContext<UploadContext | undefined>(undefined)

export const useUpload = () => {
  const context = useContext(UploadContext)
  if (!context) {
    throw new Error('useUpload must be used within an UploadProvider')
  }
  return context
}

interface UploadProviderProps {
  uploadUrl: string
  accessToken: string
  children: React.ReactNode
}

export const UploadProvider = ({uploadUrl, accessToken, children}: UploadProviderProps) => (
  <UploadContext.Provider value={{uploadUrl, accessToken}}>{children}</UploadContext.Provider>
)
